/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_SubmitInputs */

const en_cna_submit = /** @type {(inputs: Cna_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const ja_cna_submit = /** @type {(inputs: Cna_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信`)
};

const fr_cna_submit = /** @type {(inputs: Cna_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_cna_submit = /** @type {(inputs: Cna_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Cna_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_submit = /** @type {((inputs?: Cna_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_submit(inputs)
	if (locale === "ja") return ja_cna_submit(inputs)
	if (locale === "fr") return fr_cna_submit(inputs)
	return de_cna_submit(inputs)
});